<template>
  <div id="contenedor-registrar-nueva-entidad">
    <v-form
      v-model="formularioValido"
      ref="agregarEntidad">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva entidad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre de la Entidad"
            v-model="entidad.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Nombre Corto de la Entidad"
            v-model="entidad.nombreCorto"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarEntidad"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoEntridades from './mixCatalogoEntidades';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosEntidadesNuevo',
  mixins: [mixCatalogoEntridades],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      entidad: {
        nombre: '',
        nombreCorto: '',
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarEntidad.reset();
    },
  },
};
</script>

<style>
</style>
